import { h, Fragment } from "preact";
import { useState, useRef } from "preact/hooks";
import { CSSTransition } from "react-transition-group";
import { Close, Info, Swatch } from "../../helpers/icons";
import ProductOptionSwatchActions from "./product-option-swatch-actions";

export default function ProductOptionPreview({
  selectedVariant,
  selectedOptionValue,
  open,
  setOpen,
  optionInGroupSelected,
}) {
  const [id] = useState(window.crypto.randomUUID());
  const [height, setHeight] = useState(0);
  const nodeRef = useRef();

  if (!selectedVariant) return null;

  const swatch =
    optionInGroupSelected && selectedVariant.relatedProductsSwatches?.[0];

  const openDetails = () => {
    document.dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail: {
          html: `<swatch-details product-handle="${swatch.handle}"></swatch-details>`,
          target: "swatch-modal",
        },
      }),
    );
  };

  return (
    <CSSTransition
      mountOnEnter={true}
      in={open && swatch}
      nodeRef={nodeRef}
      classNames="product-options__preview-wrapper-"
      onEntering={() => {
        if (!nodeRef.current) return;
        setHeight(nodeRef.current.scrollHeight);
      }}
      onExited={() => {
        console.log("onExited");
      }}
      addEndListener={(done) => {
        nodeRef.current?.addEventListener("transitionend", done, false);
      }}
    >
      <div
        className="product-options__preview-wrapper"
        ref={nodeRef}
        style={{ "--height": `${height}px` }}
      >
        {swatch && (
          <div
            className="product-options__preview"
            role="dialog"
            aria-labelledBy={id}
          >
            <button
              type="button"
              className="product-options__preview-close"
              onClick={() => setOpen(false)}
            >
              <span className="visually-hidden">
                {window.localeStrings.accessibility.close}
              </span>
              <div className="custom-button button--white product-options__preview-close-inner">
                <Close />
              </div>
            </button>
            {swatch.featuredImage ? (
              <img
                className="product-options__preview-image"
                src={window.getSizedImageUrl(
                  swatch.featuredImage.url,
                  "500x250_crop_center",
                )}
                alt=""
              />
            ) : (
              <div className="product-options__preview-image product-options__preview-image--placeholder"></div>
            )}
            <div className="product-options__preview-info" id={id}>
              {selectedVariant.materialGroup && (
                <div className="product-options__preview-material">
                  {selectedVariant.materialGroup}
                </div>
              )}
              <div className="product-options__preview-selected-option">
                {window.localeStrings.product.in_material.replace(
                  "[material]",
                  selectedOptionValue,
                )}
              </div>
              <button
                type="button"
                className="product-options__preview-info-modal-trigger"
                onClick={openDetails}
              >
                <span className="visually-hidden">
                  {window.localeStrings.product.more_details}
                </span>
                <Info />
              </button>
              <price-snippet
                className="product-options__preview-price"
                DYNAMIC="true"
                PRICE={selectedVariant.price.amount}
                COMPARE-AT-PRICE={selectedVariant.compareAtPrice?.amount}
                CURRENCY={selectedVariant.price.currencyCode}
              ></price-snippet>
            </div>
            <ProductOptionSwatchActions
              variantId={swatch.variants[0].id.replace(
                "gid://shopify/ProductVariant/",
                "",
              )}
              price={swatch.variants[0].price.amount}
              currency={swatch.variants[0].price.currency}
              swatchType={swatch.swatchType}
            />
          </div>
        )}
      </div>
    </CSSTransition>
  );
}
